var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrij(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 28,
    viewBox: "0 0 73 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2517 21.487C68.2517 22.9528 67.5849 23.6874 66.4467 23.6874C65.2245 23.6874 64.5028 22.8692 64.5028 21.1771H59.782C59.782 25.6336 62.5864 28.0012 66.5856 28.0012C70.4459 28.0012 73 25.7451 73 21.487V8.00592H68.2517V21.487ZM47.2615 27.8045H52.0098V8.00592H47.2615V27.8045ZM15.5509 22.4183C15.5509 20.1622 14.0785 18.1323 11.8021 17.6519C13.691 17.0878 15.107 15.5367 15.107 13.1396C15.107 10.0096 12.7465 8.00756 8.77485 8.00756H0V27.8045H9.08C13.1905 27.8045 15.5509 25.6894 15.5509 22.4183ZM10.2747 13.9578C10.2747 15.3121 9.4142 16.0172 7.85943 16.0172H4.74827V11.8705H7.85781C9.4142 11.8705 10.2747 12.6034 10.2747 13.9578ZM10.7462 21.769C10.7462 23.1791 9.82913 23.912 8.24691 23.912H4.74827V19.5407H8.19202C9.77423 19.5407 10.7462 20.3589 10.7462 21.769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9163 8.00469V27.8016H27.6645V20.3282H28.8028L32.8568 27.8016H38.217L33.7189 19.9609C36.7187 19.0591 38.0507 16.7177 38.0507 14.2353C38.0507 10.7953 35.6628 8.00305 30.8855 8.00305H22.9163V8.00469ZM33.2201 14.4353C33.2201 15.9864 32.387 16.9177 30.6094 16.9177H27.6661V12.0103H30.6094C32.387 12.0103 33.2201 12.9695 33.2201 14.4353Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 0H0V3.18253H73V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrij);
export default __webpack_public_path__ + "static/media/brij.1fec35fa7df865544bb128deb068c23d.svg";
export { ForwardRef as ReactComponent };